export default __webpack_public_path__ + "static/media/956.75e24781.png";